import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	noValueTextExperiment: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	noValueTextExperiment: {
		id: 'issue-field-sprint-readview-full.sprint.no-value-text-experiment',
		defaultMessage: 'Add sprint',
		description: 'Message when the field has no value',
	},
});
export default messages;
